import { render, staticRenderFns } from "./MenuAndLight.vue?vue&type=template&id=fed34b22&scoped=true"
import script from "./MenuAndLight.vue?vue&type=script&lang=js"
export * from "./MenuAndLight.vue?vue&type=script&lang=js"
import style0 from "./MenuAndLight.vue?vue&type=style&index=0&id=fed34b22&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed34b22",
  null
  
)

export default component.exports